// Copyright (c) 2026. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import {
  Paper,
  Skeleton,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';

/**
 * Loading skeleton for fulfillment table.
 * Displays placeholder rows while data is being fetched.
 */
export function FulfillmentTableSkeleton() {
  return (
    <TableContainer component={Paper} variant="outlined">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell width="20%">References</TableCell>
            <TableCell width="25%">From/To location</TableCell>
            <TableCell width="26%">Items</TableCell>
            <TableCell width="14%">Cycle time</TableCell>
            <TableCell width="15%">Status</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {[...Array(5)].map((_, index) => (
            <TableRow key={index}>
              <TableCell>
                <Stack spacing={0.5}>
                  <Skeleton variant="text" width="60%" />
                  <Skeleton variant="text" width="80%" />
                </Stack>
              </TableCell>
              <TableCell>
                <Stack spacing={0.5}>
                  <Skeleton variant="text" width="70%" />
                  <Skeleton variant="text" width="70%" />
                </Stack>
              </TableCell>
              <TableCell>
                <Stack spacing={0.5}>
                  <Skeleton variant="text" width="50%" />
                  <Skeleton variant="text" width="50%" />
                </Stack>
              </TableCell>
              <TableCell>
                <Skeleton variant="text" width="80%" />
              </TableCell>
              <TableCell>
                <Skeleton variant="rounded" width={100} height={24} />
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
